import { DrfqHistoryStore } from '#/unified-rfqs/store/drfq-history';
import { DrfqOrderbooksStore } from '#/unified-rfqs/store/drfq-orderbooks';
import { DrfqOrdersStore } from '#/unified-rfqs/store/drfq-orders';
import GrfqQuotesStore from '#/unified-rfqs/store/grfq-quotes';
import OrdersStore from '#/unified-rfqs/store/orders';
import RfqsStore from '#/unified-rfqs/store/rfqs';
import TradesStore from '#/unified-rfqs/store/trades';
import TradeTapeStore from '#/unified-rfqs/store/trade-tape';
import { DrfqDraftsStore } from '#/unified-rfqs/store/drfq-drafts';

export default function createStores() {
  return {
    drfqOrderbooksStore: new DrfqOrderbooksStore(),
    drfqOrdersStore: new DrfqOrdersStore(),
    drfqHistoryStore: new DrfqHistoryStore(),
    drfqDraftsStore: new DrfqDraftsStore(),
    rfqStore: new RfqsStore(),
    ordersStore: new OrdersStore(),
    grfqQuoteStore: new GrfqQuotesStore(),
    tradesStore: new TradesStore(),
    tradeTapeStore: new TradeTapeStore(),
  };
}
